import { BaseApi } from 'api/base.api'

// Interface
import {
  IAboutUsProfileApi,
  IAboutUsProfileApiRequest,
  IAboutUsProfileApiGetAttrs,
  IAboutUsProfileApiGetResponse,
  IAboutUsProfileApiSaveAttrs,
  IAboutUsProfileApiSaveResponse,
  IAboutUsProfileApiGetAllAttrs,
  IAboutUsProfileApiGetAllResponse,
} from 'interfaces/back-office/content-management/about-us/profile/about-us-profile-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AboutUsProfileApi extends BaseApi<IAboutUsProfileApi> implements IAboutUsProfileApiRequest {
  readonly url = ApiConstant.CONTENT_ABOUT_US_PROFILE_URL
  private aboutUsProfileUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsProfileApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsProfileApiGetResponse>} Promise<IAboutUsProfileApiGetResponse>
   */
  async aboutUsProfile_getAboutUsProfiles(payload: IAboutUsProfileApiGetAllAttrs): Promise<IAboutUsProfileApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.aboutUsProfileUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsProfileApiGetAttrs} payload
   *
   * @return {Promise<IAboutUsProfileApiGetResponse>} Promise<IAboutUsProfileApiGetResponse>
   */
  async aboutUsProfile_getAboutUsProfile(payload: IAboutUsProfileApiGetAttrs): Promise<IAboutUsProfileApiGetResponse> {
    try {
      const response = await this.POST(`${this.aboutUsProfileUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home banner
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAboutUsProfileApiSaveAttrs} payload
   *
   * @return {Promise<IAboutUsProfileApiSaveResponse>} Promise<IAboutUsProfileApiSaveResponse>
   */
  async aboutUsProfile_saveAboutUsProfile(payload: IAboutUsProfileApiSaveAttrs): Promise<IAboutUsProfileApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.aboutUsProfileUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
